import * as actionTypes from "../actionTypes";
import initialState from "reducers/initialState";

const applicationFeaturesReducer = (state = initialState.applicationFeatures, action) => {
  switch (action.type) {
    case actionTypes.LOAD_APPLICATION_FEATURES_STARTED: {
      return {
        ...state,
        loading: true
      };
    }

    case actionTypes.LOAD_APPLICATION_FEATURES_SUCCESS: {
      return {
        ...action.payload,
        loading: false,
        loaded: true
      };
    }

    default: {
      return state;
    }
  }
};

export default applicationFeaturesReducer;
